<template>
  <v-layout
    wrap
  >
    <v-flex
      xs12
    >
      <v-layout wrap>
        <v-flex
          xs12
          md6
        >
          <v-select
            v-model="form.mainCurrency"
            :items="currencies"
            :label="$t('whitelabel.mainCurrency')+'*'"
            :error-messages="MainCurrenciesErrors"
            @blur="$v.form.mainCurrency.$touch()"
            @input="$v.form.mainCurrency.$touch()"
          />
        </v-flex>
        <v-flex xs12>
          <v-layout>
            <v-flex
              xs12
              md6
            >
              <v-text-field
                v-model.trim.number="form.minWithdrawal"
                :error-messages="MinWithdrawalErrors"
                name="min-withdrawal"
                :label="$t('whitelabel.minWithdrawal')"
                :suffix="form.mainCurrency"
                @input="$v.form.minWithdrawal.$touch()"
                @blur="$v.form.minWithdrawal.$touch()"
                @keypress="onlyForCurrency($event, form.minWithdrawal)"
              />
            </v-flex>
            <v-flex
              xs12
              md6
            >
              <v-text-field
                v-model.trim.number="form.maxWithdrawal"
                :error-messages="MaxWithdrawalErrors"
                name="max-withdrawal"
                :label="$t('whitelabel.maxWithdrawal')"
                :suffix="form.mainCurrency"
                @input="$v.form.maxWithdrawal.$touch()"
                @blur="$v.form.maxWithdrawal.$touch()"
                @keypress="onlyForCurrency($event, form.maxWithdrawal)"
              />
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
    </v-flex>
    <v-flex
      xs12
    >
      <v-layout wrap>
        <v-flex
          xs12
          md6
        >
          <v-select
            v-model="selectedCurrencies"
            multiple
            :items="currenciesOption"
            :label="$t('whitelabel.currencies')"
          />
        </v-flex>
        <v-flex
          v-if="!_.isEmpty(withdrawal_amount)"
          xs12
        >
          <v-layout 
            v-for="(item, key) in withdrawal_amount"
            :key="key"
          >
            <template v-if="key !== form.mainCurrency">
              <v-flex
                xs12
                md6
              >
                <v-text-field
                  ref="withdrawalRef"
                  v-model.number="item.min_withdrawal_amount"
                  name="min-withdrawal"
                  :label="$t('whitelabel.minWithdrawal')"
                  :suffix="key"
                  :rules="[(v) => validateField(+v, key, 'max_withdrawal_amount', true)]"
                />
              </v-flex>
              <v-flex
                xs12
                md6
              >
                <v-text-field
                  ref="withdrawalRef"
                  v-model.number="item.max_withdrawal_amount"
                  name="max-withdrawal"
                  :label="$t('whitelabel.maxWithdrawal')"
                  :suffix="key"
                  :rules="[(v) => validateField(+v, key, 'min_withdrawal_amount', false)]"
                />
              </v-flex>
            </template>
          </v-layout>
        </v-flex>
      </v-layout>
    </v-flex>
  </v-layout>
</template>

<script>
import {validationMixin} from "vuelidate";
import {
  minValue,
  maxValue,
  required
} from "vuelidate/lib/validators";

import CURRENCIES_QUERY from "@/graphql/queries/currencies.gql";

const checkMax = (param) => (value) => {
  if (!param && value) {
    return false
  }
  return value >= param;
}

const checkMin = (param) => (value) => value <= param;

export default {
  name: "WhiteLabelSettings",
  mixins: [validationMixin],
  props: {
    editForm: {
      type: Object,
      default: null
    },
  },
  data() {
    return {
      selectedCurrencies: [],
      form: {
        mainCurrency: '',
        minWithdrawal: '',
        maxWithdrawal: '',
      },
      withdrawal_amount: {},
    };
  },
  computed: {
    rules() {
      let form = {
        minWithdrawal: {
          validMin: checkMin(this.form.maxWithdrawal),
          minValue: minValue(1),
          maxValue: maxValue(50000)
        },
        maxWithdrawal: {
          validMax: checkMax(this.form.minWithdrawal),
          minValue: minValue(1),
          maxValue: maxValue(50000)
        },
        mainCurrency: {
          required
        }
      };
      return form;
    },
    MinWithdrawalErrors() {
      const errors = [];
      if (!this.$v.form.minWithdrawal.$dirty) return errors;
      !this.$v.form.minWithdrawal.minValue &&
      errors.push(this.$t("whitelabel.minValueError", {char: this.$v.form.minWithdrawal.$params.minValue.min}));
      !this.$v.form.minWithdrawal.maxValue &&
      errors.push(this.$t("whitelabel.maxValueError", {char: this.$v.form.minWithdrawal.$params.maxValue.max}));
      !this.$v.form.minWithdrawal.validMin &&
      errors.push(this.$t("whitelabel.minWithdrawalError"));
      return errors;
    },
    MaxWithdrawalErrors() {
      const errors = [];
      if (!this.$v.form.maxWithdrawal.$dirty) return errors;
      !this.$v.form.maxWithdrawal.minValue &&
      errors.push(this.$t("whitelabel.minValueError", {char: this.$v.form.maxWithdrawal.$params.minValue.min}));
      !this.$v.form.maxWithdrawal.maxValue &&
      errors.push(this.$t("whitelabel.maxValueError", {char: this.$v.form.maxWithdrawal.$params.maxValue.max}));
      !this.$v.form.maxWithdrawal.validMax &&
      errors.push(this.$t("whitelabel.maxWithdrawalError"));
      return errors;
    },
    MainCurrenciesErrors(value) {
      const errors = [];
      if (!this.$v.form.mainCurrency.$dirty) return errors;
      !this.$v.form.mainCurrency.required && errors.push(this.$t("profile.reqField"));
      return errors;
    },
    currenciesOption() {
      return this.currencies && this.currencies.length !== 0 ? this.currencies.filter(name => name !== this.form.mainCurrency) : []
    },
  },
  watch: {
    editForm(value) {
      if (value) {
        this.parseEditForm(value);
      }
    },
    selectedCurrencies(valueNew, valueOld) {
      if(valueNew.length !== 0) {
        if(valueNew.length < valueOld.length) {
          const deleteCurrency = valueOld.find(v => !valueNew.includes(v));
          delete this.withdrawal_amount[deleteCurrency];
        } else {
          valueNew.forEach(name => {
            if(!this.withdrawal_amount.hasOwnProperty(name)) {
              this.withdrawal_amount[name] = {
                min_withdrawal_amount: '',
                max_withdrawal_amount: ''
              }
            }
          });
        }
      } else {
        this.withdrawal_amount = {};
      }
    },
    "form.mainCurrency"(value) {
      if(value) {
        this.selectedCurrencies = this.selectedCurrencies.filter(name => name !== value);
        delete this.withdrawal_amount[value];
      }
    }
  },
  validations() {
    return {
      form: this.rules
    };
  },
  mounted() {
    if (this.editForm) {
      this.parseEditForm(this.editForm)
    }
  },
  methods: {
    validateField(value, key, field, minCheck) {
      if(!value && !this.withdrawal_amount[key][field]) {
        return true
      }
      if(value < 1) {
        return this.$t("whitelabel.minValueError", {char: 1});
      }
      if(value > 50000) {
        return this.$t("whitelabel.maxValueError", {char: 50000})
      }
      if(isNaN(value)) {
        return this.$t("globals.mustBeNumber")
      }
      if(minCheck) {
        const check_min = checkMin(value)(this.withdrawal_amount[key][field]);
        if(check_min) {
          return this.$t("whitelabel.minWithdrawalError");
        }
      }
      if(!minCheck) {
        const check_max = checkMax(value)(this.withdrawal_amount[key][field]);
        if(check_max) {
          return this.$t("whitelabel.maxWithdrawalError");
        }
      }
      if(!value && this.withdrawal_amount[key][field]) {
        return this.$t("profile.reqField")
      }
      
      return true
    },
    parseEditForm(editForm) {
      const value = editForm;
      if (value.settings) {
        let getWithdrawal = value.settings.withdrawal_amount
            ? JSON.parse(value.settings.withdrawal_amount) : null;
        if(getWithdrawal && getWithdrawal.hasOwnProperty(value.currency)) {
          this.form = {
            ...this.form,
            minWithdrawal: getWithdrawal[value.currency].min_withdrawal_amount || '',
            maxWithdrawal: getWithdrawal[value.currency].max_withdrawal_amount || '',
          }
        }
        if(getWithdrawal) {
          delete getWithdrawal[value.currency];
          this.withdrawal_amount = getWithdrawal;
        }
      }
      const currencies = value.supported_currencies && value.supported_currencies.map(({name}) => name);
      this.selectedCurrencies = currencies || [];
      this.form.mainCurrency = value.currency || ''
    },
    async save() {
      this.$v.$touch();
      let validateInput = [];
      if(this.$refs.withdrawalRef) {
        validateInput = await this.$refs.withdrawalRef.filter(
          (input) => input.validate() === false
        );
      }
      if(this.$v.$invalid || validateInput.length !== 0) {
        return
      }
      if ((this.form.minWithdrawal < 1 || this.form.maxWithdrawal < 1) &&
          this._.isEmpty(this.withdrawal_amount)) {
        const form = {
          currency: this.form.mainCurrency,
          supported_currencies: this.selectedCurrencies
        }
        this.$emit('saveForm', form);
      } else {
        if (!this.$v.$invalid) {
          let withdrawal_amount = this.withdrawal_amount;
          if(this.form.minWithdrawal >= 1 || this.form.maxWithdrawal >= 1) {
            withdrawal_amount[this.form.mainCurrency] = {
              min_withdrawal_amount: this.form.minWithdrawal,
              max_withdrawal_amount: this.form.maxWithdrawal,
            }
          }
          const form = {
            currency: this.form.mainCurrency,
            settings: {
              withdrawal_amount: JSON.stringify(withdrawal_amount)
            },
            supported_currencies: this.selectedCurrencies,
          }
          this.$emit('saveForm', form);
        }
      }
    },
  },
  apollo: {
    currencies: {
      query: CURRENCIES_QUERY,
    },
  }
};
</script>

<style lang="scss">

</style>